export default __webpack_public_path__ + "assets/images/6.ac8a4d.png";